var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex h-full w-full rounded-lg overflow-hidden"},[_c('Editor',{staticClass:"grow w-full basis-full",attrs:{"api-key":"c21xora5cqvlh2qa9snoh4syuep4gwac8piuek5ozs52u839","init":{
       width: '100%',
       skin: 'oxide-dark',
       content_css: 'dark',
      toolbar:
      'undo redo | formatselect | bold italic backcolor | \
      alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | removeformat | help'
    }},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }